import React from "react";
import logo from "../assets/icon.png";

function ComingSoon() {
  return (
    <div className="comingSoonContainer">
      <img
        src={logo}
        alt="TinyAR Logo"
        className="logo"
        style={{ width: "100px", margin: "0" }}
      />
      <h1 style={{ margin: "0", fontSize: "50px" }}>Tiny AR</h1>
      <p>Coming soon 👀</p>
    </div>
  );
}

export default ComingSoon;
